import { c as _c } from "react/compiler-runtime";
import { useState, useCallback } from 'react';
import { useApolloClient, useQuery } from '@apollo/client';
import { GET_CART, GET_CLOSEST_STORES_FROM_ZIPCODE } from 'mocks/queries';
import { ZIP_CODE_REGEX, ZIPCODE_ERROR_MESSAGES } from 'commons/constants';
import { logError } from 'commons/logger';
import useSetZipCodeFromUser from 'global-state/zipCodeFromUser/useSetZipCodeFromUser';
const EMPTY_STORES = [];
export const validateZipcodeInput = inputs => {
  if (!inputs.zipcode.toString().trim()) {
    return {
      zipcode: ZIPCODE_ERROR_MESSAGES.ZIPCODE_IS_EMPTY
    };
  }
  if (!ZIP_CODE_REGEX.test(inputs.zipcode)) {
    return {
      zipcode: ZIPCODE_ERROR_MESSAGES.ZIPCODE_IS_INVALID_FORMAT
    };
  }
  return {};
};
const useShowroomLocator = () => {
  const $ = _c(16);
  const apolloClient = useApolloClient();
  const [searchZipcode, setSearchZipcode] = useState("");
  const [hasSearched, setHasSearched] = useState(false);
  const setZipCodeFromUser = useSetZipCodeFromUser();
  let t0;
  if ($[0] !== searchZipcode) {
    t0 = {
      zipcode: searchZipcode,
      limit: 5
    };
    $[0] = searchZipcode;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = !hasSearched || !searchZipcode;
  let t2;
  if ($[2] !== t0 || $[3] !== t1) {
    t2 = {
      variables: t0,
      skip: t1,
      errorPolicy: "all"
    };
    $[2] = t0;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const {
    data,
    loading,
    error
  } = useQuery(GET_CLOSEST_STORES_FROM_ZIPCODE, t2);
  const stores = data?.getClosestStoresFromZipcode || EMPTY_STORES;
  let t3;
  if ($[5] !== apolloClient || $[6] !== setZipCodeFromUser) {
    t3 = zipcode => {
      const trimmedZipCode = zipcode.trim();
      setSearchZipcode(trimmedZipCode);
      setHasSearched(true);
      setZipCodeFromUser(trimmedZipCode);
      apolloClient.refetchQueries({
        include: [GET_CART]
      }).catch(_temp);
    };
    $[5] = apolloClient;
    $[6] = setZipCodeFromUser;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const handleSearch = t3;
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      setHasSearched(false);
    };
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const handleCloseResults = t4;
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      setSearchZipcode("");
      setHasSearched(false);
    };
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const handleViewAll = t5;
  let t6;
  if ($[10] !== error || $[11] !== handleSearch || $[12] !== hasSearched || $[13] !== loading || $[14] !== stores) {
    t6 = {
      stores,
      loading,
      error,
      hasSearched,
      handleSearch,
      handleCloseResults,
      handleViewAll
    };
    $[10] = error;
    $[11] = handleSearch;
    $[12] = hasSearched;
    $[13] = loading;
    $[14] = stores;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
};
export default useShowroomLocator;
function _temp(refetchError) {
  logError(refetchError, "Failed to refetch GET_CART after showroom zip search");
}